import { API, fileUrl } from "./api";

export const PWA_DEFAULTS = {
  enabled: false, app_name: "", short_name: "", description: "", icon: "",
  theme_color: "#111111", background_color: "#ffffff",
  splash_logo: "", splash_bg: "", splash_animation: "spinner", splash_text: "", splash_duration_ms: 1200,
  start_page: "home", install_button: true, promo_banner: true, updated_by: "", updated_at: "",
};

export const mergePwa = (store) => {
  const p = { ...PWA_DEFAULTS, ...((store && store.pwa) || {}) };
  if (!p.app_name) p.app_name = store?.name || "Store";
  return p;
};

export const isStandalone = () =>
  (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true;

export const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent || "");

export const pwaSupported = () => typeof navigator !== "undefined" && "serviceWorker" in navigator;

export function applyManifest(slug, pwa) {
  let link = document.querySelector("link[rel='manifest']");
  if (!link) { link = document.createElement("link"); link.rel = "manifest"; document.head.appendChild(link); }
  link.href = `${API}/public/store/${slug}/manifest.json`;
  const ensureMeta = (name, content) => {
    let m = document.querySelector(`meta[name='${name}']`);
    if (!m) { m = document.createElement("meta"); m.name = name; document.head.appendChild(m); }
    m.content = content;
  };
  ensureMeta("theme-color", pwa.theme_color || "#111111");
  ensureMeta("apple-mobile-web-app-capable", "yes");
  ensureMeta("mobile-web-app-capable", "yes");
  ensureMeta("apple-mobile-web-app-title", pwa.short_name || pwa.app_name || "App");
  ensureMeta("apple-mobile-web-app-status-bar-style", "default");
  const icon = pwa.icon ? fileUrl(pwa.icon) : `${API}/public/store/${slug}/pwa-icon/192.png`;
  let touch = document.querySelector("link[rel='apple-touch-icon']");
  if (!touch) { touch = document.createElement("link"); touch.rel = "apple-touch-icon"; document.head.appendChild(touch); }
  touch.href = icon;
}

export async function registerStoreSw(slug) {
  if (!pwaSupported()) return false;
  try {
    await navigator.serviceWorker.register(`${API}/public/store/${slug}/sw.js`, { scope: "/" });
    return true;
  } catch { return false; }
}

let deferred = null;
let installed = false;
const subs = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; subs.forEach((f) => f()); });
  window.addEventListener("appinstalled", () => { installed = true; deferred = null; subs.forEach((f) => f()); });
}
export const onInstallState = (f) => { subs.add(f); return () => subs.delete(f); };
export const canPromptInstall = () => !!deferred;
export const wasInstalled = () => installed;
export const promptInstall = async () => {
  if (!deferred) return false;
  deferred.prompt();
  const r = await deferred.userChoice.catch(() => null);
  deferred = null;
  return r?.outcome === "accepted";
};

const dismissKey = (slug) => `pwa_dismiss_${slug}`;
export const isDismissed = (slug) => {
  try { return Date.now() - Number(localStorage.getItem(dismissKey(slug)) || 0) < 7 * 864e5; } catch { return false; }
};
export const dismissBanner = (slug) => { try { localStorage.setItem(dismissKey(slug), String(Date.now())); } catch { /* noop */ } };

export const splashSeenKey = (slug) => `pwa_splash_${slug}`;
